module.exports = __webpack_public_path__ + "img/33.45d6b934.jpg";